export const testimonials = [
  {
    id: 'daniel',
    name: 'Daniel Mercer',
    role: 'Prop desk trader',
    location: 'London, UK',
    rating: 5,
    quote:
      'I have burned money on martingale EAs before, so I was sceptical. This is the first gold bot where I can actually sleep at night — every trade ships with a stop attached and the lot size never balloons.',
    avatar:
      'https://readdy.ai/api/search-image?query=Editorial%20studio%20portrait%20headshot%20of%20a%20man%20in%20his%20late%20thirties%20with%20short%20brown%20hair%20and%20light%20stubble%2C%20neutral%20warm%20ivory%20background%2C%20soft%20diffused%20lighting%2C%20shallow%20depth%20of%20field%2C%20calm%20confident%20expression%2C%20professional%20photography&width=200&height=200&seq=testi-avatar-01&orientation=squarish',
  },
  {
    id: 'aisha',
    name: 'Aisha Rahman',
    role: 'Retail investor',
    location: 'Dubai, UAE',
    rating: 5,
    quote:
      'Set it up on a Sunday and it was trading by Monday morning. The preset matched my $2,000 account exactly and the risk is precisely what they described — no surprises, no hidden settings.',
    avatar:
      'https://readdy.ai/api/search-image?query=Editorial%20studio%20portrait%20headshot%20of%20a%20woman%20in%20her%20early%20thirties%20wearing%20an%20elegant%20neutral%20headscarf%2C%20warm%20ivory%20background%2C%20soft%20diffused%20lighting%2C%20shallow%20depth%20of%20field%2C%20composed%20friendly%20expression%2C%20professional%20photography&width=200&height=200&seq=testi-avatar-02&orientation=squarish',
  },
  {
    id: 'marcus',
    name: 'Marcus Novak',
    role: 'Systems developer',
    location: 'Prague, Czechia',
    rating: 5,
    quote:
      'What I respect most is the honesty. They publish a real live account instead of a cherry-picked backtest, and when February went red they left it on display. That transparency is rare.',
    avatar:
      'https://readdy.ai/api/search-image?query=Editorial%20studio%20portrait%20headshot%20of%20a%20bearded%20man%20in%20his%20forties%20wearing%20glasses%2C%20neutral%20warm%20ivory%20background%2C%20soft%20diffused%20lighting%2C%20shallow%20depth%20of%20field%2C%20thoughtful%20expression%2C%20professional%20photography&width=200&height=200&seq=testi-avatar-03&orientation=squarish',
  },
  {
    id: 'sofia',
    name: 'Sofia Bianchi',
    role: 'Portfolio manager',
    location: 'Milan, Italy',
    rating: 5,
    quote:
      'I ran it alongside my manual gold trading for three months. The EA stayed calmer than I did — no revenge trades, no chasing moves. In the end I let it run full time on a dedicated chart.',
    avatar:
      'https://readdy.ai/api/search-image?query=Editorial%20studio%20portrait%20headshot%20of%20a%20woman%20in%20her%20late%20twenties%20with%20long%20dark%20hair%2C%20neutral%20warm%20ivory%20background%2C%20soft%20diffused%20lighting%2C%20shallow%20depth%20of%20field%2C%20elegant%20confident%20expression%2C%20professional%20photography&width=200&height=200&seq=testi-avatar-04&orientation=squarish',
  },
  {
    id: 'kenji',
    name: 'Kenji Watanabe',
    role: 'Part-time trader',
    location: 'Tokyo, Japan',
    rating: 4,
    quote:
      'Support actually replies. I asked a beginner question about the M15 chart late at night and got a clear answer with a screenshot. For a completely free EA, that level of help is unheard of.',
    avatar:
      'https://readdy.ai/api/search-image?query=Editorial%20studio%20portrait%20headshot%20of%20an%20asian%20man%20in%20his%20mid%20thirties%20with%20neat%20black%20hair%2C%20neutral%20warm%20ivory%20background%2C%20soft%20diffused%20lighting%2C%20shallow%20depth%20of%20field%2C%20calm%20expression%2C%20professional%20photography&width=200&height=200&seq=testi-avatar-05&orientation=squarish',
  },
  {
    id: 'priya',
    name: 'Priya Nair',
    role: 'Funded trader',
    location: 'Singapore',
    rating: 5,
    quote:
      'The monthly returns do swing, but that is gold for you. What matters to me is that nothing ever blew up the account over ten months. Risk control is the entire selling point and it delivers.',
    avatar:
      'https://readdy.ai/api/search-image?query=Editorial%20studio%20portrait%20headshot%20of%20a%20south%20asian%20woman%20in%20her%20thirties%20with%20shoulder%20length%20hair%2C%20neutral%20warm%20ivory%20background%2C%20soft%20diffused%20lighting%2C%20shallow%20depth%20of%20field%2C%20warm%20smile%2C%20professional%20photography&width=200&height=200&seq=testi-avatar-06&orientation=squarish',
  },
];